export const useDate = () => {
  const runtimeConfig = useRuntimeConfig()
  const days = runtimeConfig.public.numberOfDaysInFeed ? Number(runtimeConfig.public.numberOfDaysInFeed) : 0
  const dayjs = useDayjs()

  const todayString = () => {
    const now = new Date()
    now.setHours(0)
    now.setMinutes(0)
    now.setSeconds(0)
    now.setUTCDate(now.getUTCDate() - days)
    return now.toISOString()
  }

  const getPreciseTime = () => {
    const now = new Date()
    return `${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}.${now.getMilliseconds()}`
  }

  const getFormatedDate = (date: Date) => {
    const {t} = useI18n()
    const d = dayjs(date)
    let month = t(`datetime.months.${d.month()}`)

    return `${d.date()}. ${month} ${d.year()}`
  }

  const getFormatedTime = (date: Date) => {
    const d = dayjs(date)
    return `${d.hour()}:${('0'+d.minute()).slice(-2)}`
  }

  const addMinutes = (date: Date, minutes: number = 0) => {
    date.setTime(date.getTime() + (minutes * 60 * 1000))
    return date
  }

  return {
    todayString,
    getPreciseTime,
    getFormatedDate,
    getFormatedTime,
    addMinutes,
  }
}
